import Axios from 'axios'
import config from './config'
import { callAuthenticatedApi } from './authenticated-api'

const apiUrls = {
  remote : config.templatesRemoteApiUrl,
  local : config.templatesLocalApiUrl 
}

const apiError = (err, fallbackMessage) => err.response?.data ?? { ok: false, error: { message: fallbackMessage } }

const getSystemTemplates = async ({apiSource,apiKey}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getSystemTemplates`,
    }

    let data = await callApi({apiKey,options})
    return data.templates
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting system templates")
  }
}

const getClientTemplates = async ({apiSource,apiKey}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getClientTemplates`,
    }

    let data = await callApi({apiKey,options})
    return data.templates
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting client templates")
  }
}


const getClientTemplate = async ({apiSource,apiKey, templateId}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getClientTemplate/${templateId}`,
    }

    let data = await callApi({apiKey,options})
    return data.template
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting client template")
  }
}

const updateClientImage = async ({apiSource,apiKey,image}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateClientImage`,
      method: "patch",
      data:{
        image
      }
    }

    return await callApi({apiKey,options})  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error updating image")
  }
} 


const getTemplateData = async ({apiSource,apiKey, templateId}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getTemplateData/${templateId}`,
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting template data")
  }
}

const createTemplate = async ({apiSource,apiKey,templateId,templateName}) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/createTemplate`,
      data : {
        sourceTemplateId : templateId,
        newTemplateName : templateName,
      }
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error creating template")
  }
}

const duplicateTemplate = async ({apiSource,apiKey,templateId,newtemplateName}) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/duplicateTemplate`,
      data : {
        sourceTemplateId : templateId,
        newTemplateName : newtemplateName,
      }
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error duplicating template")
  }
}


const archiveTemplate = async ({apiSource,apiKey, templateId}) => {
  try {
    let options = {
      method: 'PATCH',
      url: `${apiUrls[apiSource]}/archiveTemplate/` + templateId
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error archiving template")
  }
}

const unarchiveTemplate = async ({apiSource,apiKey,templateId}) => {
  try {
    let options = {
      method: 'PATCH',
      url: `${apiUrls[apiSource]}/unarchiveTemplate/` + templateId
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error unarchiving template")
  }
}

const searchGooglePlaystore = async ({apiSource,apiKey, searchTerm}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/searchGooglePlayStore`,
      method: "get",
      params: {
        term: searchTerm
      }
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error searching playstore")
  }
}

const searchAppleAppstore = async ({ apiSource, apiKey, countryCode, searchTerm }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/searchAppleAppstore`,
      method: "get",
      params: {
        countryCode,
        term : searchTerm
      }
    }

    return await callApi({apiKey,options})  
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error searching appstore")
  }
}

const saveAppleModel = async ({ apiSource, apiKey,templateId,appleModel }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateAppleModel`,
      method: "post",
      data : {
        templateId,
        appleModel
      }
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving apple model")
  }
}

const saveAppleTemplate = async ({ apiSource, apiKey,templateId,appleTemplate }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateAppleTemplate`,
      method: "post",
      data : {
        templateId,
        appleTemplate
      }
    }

    let result = await callApi({apiKey,options})
    
    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving apple template")
  }
}


const saveGoogleData = async ({ apiSource, apiKey,templateId,googleClass, googleObject }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateGoogleData`,
      method: "post",
      data : {
        templateId,
        googleClass,
        googleObject
      }
    }

    let result = await callApi({apiKey,options})

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving google both")
  }
}

const saveGoogleClass = async ({ apiSource, apiKey,templateId,googleClass }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateGoogleClass`,
      method: "post",
      data : {
        templateId,
        googleClass
      }
    }

    let result = await callApi({apiKey,options})

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving google class")
  }
}

const saveGoogleObject = async ({ apiSource, apiKey,templateId,googleObject }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateGoogleObject`,
      method: "post",
      data : {
        templateId,
        googleObject
      }
    }

    let result = await callApi({apiKey,options})

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving apple object")
  }
}

const saveMetaData = async ({ apiSource, apiKey,templateId,metaData }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateMetaData`,
      method: "post",
      data : {
        templateId,
        metaData
      }
    }

    let result = await callApi({apiKey,options})

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving meta data")
  }
}
const saveVariables = async ({ apiSource, apiKey,templateId,variables, customVariables }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateVariables`,
      method: "post",
      data : {
        templateId,
        variables,
        customVariables
      }
    }

    let result = await callApi({apiKey,options})

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving instance data")
  }
}


const setGoogleBarcodeHandling  = async ({ apiSource, apiKey, templateId, disableBarcode }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/setGoogleBarcodeHandling/${templateId}/${disableBarcode ? 1 : 0}`,
      method: "patch",
      data : {}
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error setting google barcode handling")
  }
}

const getTemplateIssueData = async ({apiSource,apiKey,templateId}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getTemplateIssueData/${templateId}`,
      method: "get"
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting issue data")
  }
}

const uploadClientImage = async ({apiSource,apiKey,device,imageType, passType,filename,base64Data}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/uploadClientImage`,
      method: "put",
      data:{
        device,
        image_type : imageType,
        pass_type : passType,
        filename,
        base64Data
      }
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error uploading image")
  }
}

const uploadTemplatePreview = async ({ apiSource, apiKey, templateId, base64Data, platform = "apple", ownerClientId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/uploadTemplatePreview`,
      method: "put",
      data: {
        templateId,
        base64Data,
        platform,
        ownerClientId
      }
    }

    return await callApi({ apiKey, options })
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error uploading template preview")
  }
}

const getClientImages = async ({apiSource,apiKey,filetypes=["png","jpg","jpeg"]}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getClientImages`,
      method: "get"
    }

    const result = await callApi({apiKey,options})
    result.images = result.images.filter(i => filetypes.includes(i.file_type))
    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting images")
  }
}


const getPassTypeData = async ({apiSource,apiKey, passType}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getPassTypeData/` + passType,
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting pass type data")
  }
}


const saveScannerConfiguration = async ({apiSource,apiKey,templateId,scannerData}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveScannerConfiguration/${templateId}`,
      method: "patch",
      data:{scannerData}
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving scanner configuration")
  }
}

const getScanReportDates = async ({apiSource,apiKey,templateId}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getScanReportDates/${templateId}`,
      method: "get",
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting scan report dates")
  }
}


const getScanReportScans = async ({apiSource,apiKey,templateId,ts}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getScanReportScans/${templateId}/${ts}`,
      method: "get",
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting scan report scans")
  }
}

const renameTemplate = async ({apiSource,apiKey,templateId,name}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/renametemplate/${templateId}/${name}`,
      method: "patch",
    }

    return await callApi({apiKey,options})
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error renaming template")
  }
}

const callApi = async ({apiKey,options}) => {
  try {
    return await callAuthenticatedApi({
      apiSource: getApiSourceFromUrl(options.url),
      apiKey,
      includeChildClientId: true,
      options
    })
  }
  catch (err) {
    throw err
  }
}

const getApiSourceFromUrl = url => {
  return url?.startsWith(apiUrls.local) ? 'local' : 'remote'
}

export {
  archiveTemplate, 
  createTemplate, 
  duplicateTemplate,
  getClientTemplate,
  getClientTemplates,
  getPassTypeData,
  getClientImages,
  getSystemTemplates,
  getTemplateData,
  getTemplateIssueData,
  saveAppleModel,
  saveAppleTemplate,
  saveGoogleClass,
  saveGoogleData,
  saveGoogleObject,
  saveMetaData,
  saveVariables,
  saveScannerConfiguration,
  searchAppleAppstore,
  searchGooglePlaystore,
  setGoogleBarcodeHandling,
  unarchiveTemplate,
  updateClientImage,
  uploadClientImage,
  uploadTemplatePreview,
  getScanReportDates,
  getScanReportScans,
  renameTemplate,
}
